import fetchData, { APIURL, getData, postData } from "../fetch";


/**
 * @typedef {{
 *  id: string
 *  title: string
 *  category_id: string 
 *  category: string|import("./vehicle-categories").VehicleCategoryObject
 *  code: string 
 *  registration_no: string
 *  manufacture_year: number
 *  colour: string 
 *  chassis_no: ?string 
 *  engine_no: ?string
 *  logbook_no: ?string
 *  status: "yard"|"maintenance"|"field"|"inactive" 
 *   make: string
 *  model: string
 *  description: string
 * }} VehicleObject
 */


/**
 * 
 * @param {VehicleObject} data 
 * @returns {Promise<{code: number, message: string, vehicle: VehicleObject}>}
 */
const createVehicle = data => postData({ url: `${APIURL}/vehicles`, data })


/**
 * get vehicle details
 * @param {String} id 
 * @param {string[]} include
 * @returns {Promise<{code: number, message: string, vehicle: VehicleObject}>}
 */
const getVehicle = (id, include = []) => fetchData({ url: `${APIURL}/vehicles/${id}`, data: { include: include.join(",") } })


/**
 * @param {VehicleObject} data 
 * @param {string} id
 * @returns {Promise<{code: number, message: string, vehicle: VehicleObject}>}
 */
const updateVehicle = (data, id) => postData({ url: `${APIURL}/vehicles/${id}`, data })

/**
 * 
 * @param {boolean} getAll If to get the expanded list  
 * @returns {Promise<{code: number, message: string, vehicles: VehicleObject[]}>}
 */
const getVehicles = (getAll = false, conditions = null) => {
    const obj = { url: `${APIURL}/vehicles`, data: {} }
    if (getAll) obj.data.expanded = 1;
    if (conditions) obj.data = { ...obj.data, ...conditions };
    return getData(obj);
}




export {
    getVehicle,
    getVehicles,
    createVehicle,
    updateVehicle
}